import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IImageLibraryQuery } from '../interfaces/image-library.query.interface';
import { ImageLibraryCommand } from '../models/image-library.command';
import { ImageLibrary } from '../models/image-library.model';

@Injectable()
export class ImageLibraryApiService extends EntityService<IImageLibraryQuery, ImageLibraryCommand> implements IEntityApiService<ImageLibrary> {
    private _imageLibraryConfig: ImageLibrary;
    fetchingConfig = false;

    get imageLibraryConfig(): ImageLibrary {
        return this._imageLibraryConfig;
    }

    set imageLibraryConfig(value: ImageLibrary) {
        this._imageLibraryConfig = value;
    }

    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'tenant-config');
    }

    getAll(): Observable<ImageLibrary[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new ImageLibrary(query))));
    }

    create(entity: ImageLibrary): Observable<ImageLibrary> {
        const data = new ImageLibraryCommand(entity);

        return this._create(data).pipe(map((query) => new ImageLibrary(query)));
    }

    read(id: string): Observable<ImageLibrary> {
        return this._read(id).pipe(map((query) => new ImageLibrary(query)));
    }

    update(entity: ImageLibrary): Observable<ImageLibrary> {
        const data = new ImageLibraryCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new ImageLibrary(query)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }

    getImageLibraryConfig(): Observable<boolean> {
        this.fetchingConfig = true;
        return this.http.get<IImageLibraryQuery[]>(`${this.apiUrl}/tenant-config?configKey=central_image_library`).pipe(
            map((queries) => {
                this.imageLibraryConfig = new ImageLibrary(queries[0]);
                return true;
            })
        );
    }

    async updateImageLibraryConfig(config: ImageLibrary): Promise<ImageLibrary> {
        const data = {
            config_key: config.configKey,
            config_value: config.configVal,
        };
        return this.http
            .put<IImageLibraryQuery>(`${this.apiUrl}/tenant-config/${config.id}`, data)
            .pipe(map((query) => new ImageLibrary(query)))
            .toPromise();
    }
}
